import React from 'react'
import {CheckCircle, Users, Target, Shield, BarChart3, MessageSquare, FileText, Smartphone} from 'lucide-react'

const services = [
  {
    icon: CheckCircle,
    title: 'Project Management',
    description: 'End-to-end project management services to ensure your initiatives are delivered on time and within budget'
  },
  {
    icon: Users,
    title: 'Change Management',
    description: 'Guide your organization through seamless transitions with structured change management strategies'
  },
  {
    icon: Target,
    title: 'Business Process Optimization',
    description: 'Streamline operations and eliminate inefficiencies to maximize productivity and reduce costs'
  },
  {
    icon: FileText,
    title: 'Digital Content',
    description: 'Create engaging and effective digital content strategies to enhance your brand presence'
  },
  {
    icon: Shield,
    title: 'Risk Management',
    description: 'Identify, assess, and mitigate risks to protect your business and ensure project success'
  },
  {
    icon: BarChart3,
    title: 'Data Analytics',
    description: 'Transform your data into actionable insights to drive informed business decisions'
  },
  {
    icon: Smartphone,
    title: 'Mobile & eNotary',
    description: 'Modern mobile solutions and secure electronic notary services for digital transformation'
  },
  {
    icon: MessageSquare,
    title: 'Business Transformation',
    description: 'Tailored approach to guide your business through seamless transitions for sustainable impact'
  }
]

export default function Services() {
  return (
    <div className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Comprehensive Consulting Services
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            We offer tailored project consulting services designed to meet your specific business needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div key={index} className="group bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-xl p-6 hover:border-emerald-500/50 hover:bg-slate-800 transition-all duration-300 hover:shadow-lg hover:shadow-emerald-500/10">
              <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <service.icon className="w-6 h-6 text-white" />
              </div>
              
              <h3 className="text-lg font-bold text-white mb-3 group-hover:text-emerald-400 transition">
                {service.title}
              </h3>
              
              <p className="text-gray-400 text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
